export default __webpack_public_path__ + "static/media/earth.68bcf290.svg";